import * as actionTypes from './actionTypes';
import axios from "../../axios";
import {API} from "../../constants";
import i18n from "../../i18n";

export const setUserInfo = (token) => {
    return {
        type: actionTypes.SET_USER_INFO,
        token: token
    };
};

export const removeUserInfo = () => {
    return {
        type: actionTypes.REMOVE_USER_INFO,
    };
};

export const setAffiliateInfo = (data) => {
    return {
        type: actionTypes.SET_AFFILIATE_INFO,
        me: data
    };
};

export const getAffiliateInfo = () => {
    return async dispatch => {
        const response = await axios.get(`${API}${i18n.language}/affiliate/me`)
        const resData = await response.data;
        dispatch(setAffiliateInfo(resData));
    };
};
